export default __webpack_public_path__ + "static/media/dongho_big.4f772055.png";